import React, { useState } from "react";
import {
  IconButton,
  makeStyles,
  Popover,
  Slider,
  Theme,
  Typography,
} from "@material-ui/core";
import { MoreHoriz } from "@material-ui/icons";
import { useVi } from "../contexts/ViContext";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.grey[900],
    },
    transition: "all 0.382s ease-out",
    transform: "translateY(15%)",
    position: "absolute",
    bottom: 0,
    right: 0,
  },
  popover: {
    display: "flex",
    flexFlow: "column nowrap",
    width: "15rem",
    padding: "0.618rem 1.618rem",
  },
}));

export const Thresholds = () => {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(null);
  const classes = useStyles();

  const {
    thresholds: { globalThreshold },
    onConfidenceThresholdChange,
  } = useVi();
  return (
    <>
      <IconButton
        size="small"
        disableFocusRipple
        disableRipple
        disableTouchRipple
        className={classes.button}
        onClick={(e) => setPopoverAnchor(e.currentTarget)}
      >
        <MoreHoriz />
      </IconButton>
      <Popover
        classes={{ paper: classes.popover }}
        id="thresholds"
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        onClose={() => setPopoverAnchor(null)}
      >
        <Typography gutterBottom variant="overline">
          Global Confidence Threshold
        </Typography>
        <Slider
          marks={[...Array(21).keys()].map((a) => ({
            value: a * 0.05,
            label: a === 0 ? "0%" : a === 8 ? "40%" : a === 20 ? "100%" : undefined,
          }))}
          min={0}
          max={1}
          step={0.05}
          scale={(x) => Math.round(x * 100)}
          track="inverted"
          color="secondary"
          valueLabelDisplay="auto"
          aria-label={"Global Confidence Threshold"}
          value={globalThreshold}
          onChange={(e, value) =>
            onConfidenceThresholdChange({ globalThreshold: value as number })
          }
        />
      </Popover>
    </>
  );
};
